export const PRODUCTION_HOSTNAME = 'chamalo-front.camalo.fr';

/** Every host other than the production one (localhost, dev, staging...) is a non-production environment. */
export const isNonProductionHost = (hostname: string = window.location.hostname) => hostname !== PRODUCTION_HOSTNAME;
